import React from 'react';
import { Avatar as AAvatar, Tooltip } from 'antd';
import styled from 'styled-components';
import Image from 'components/Image';
import { UserFemaleIcon, UserMaleIcon } from 'components/Icons';

const AvatarStyled = styled(AAvatar)`
    background-color: #fff;
`;

const DefaultAvatarImage = ({ person, ...restProps }) => {
    if (person.sex === 'f') {
        return <UserFemaleIcon style={{ color: '#b7cbd9' }} {...restProps} />;
    } else {
        return <UserMaleIcon style={{ color: '#b7cbd9' }} {...restProps} />;
    }
};

interface Props {
    person: Person;
    size?: number;
    avatarProps?: Record<string, string>;
    photoDimensions?: {
        width: number;
        height: number;
    };
}

const Avatar = ({
    person,
    size = 64,
    photoDimensions = { width: 92, height: 92 },
    avatarProps,
    ...restProps
}: Props): JSX.Element => {
    return (
        <AvatarStyled
            size={size}
            icon={
                <Tooltip
                    title={person.name || `${person.firstName} ${person.lastName}`}
                    placement="top"
                >
                    {person.photo ? (
                        <Image
                            type="avatar"
                            {...photoDimensions}
                            src={person.photo}
                            alt={person.name || `${person.firstName} ${person.lastName}`}
                        />
                    ) : (
                        <DefaultAvatarImage person={person} {...avatarProps} />
                    )}
                </Tooltip>
            }
            {...restProps}
        />
    );
};

export default Avatar;
